// extracted by mini-css-extract-plugin
export default {"register-message":"RegisterMessage_register-message__+RmDB","title":"RegisterMessage_title__4LlmV"};